import { Col, Row } from "antd";
import React, { useEffect, useState } from "react";
import ItemCard from "../../../../common/components/ItemCard";
import ItemListCard from "../../../../common/components/ItemListCard";
import { ItemCardStatus } from '../../../../common/types/types'
import { AuctionResponse, StartStatus } from "../../../types";

interface AuctionListViewProps {
    type: "list" | "grid",
    auctionList: AuctionResponse[],
    reloadPage: () => void,
}

const AuctionListView = ({ type, auctionList, reloadPage }: AuctionListViewProps) => {
    const [itemList, setItemList] = useState<React.ReactNode[]>([]);

    useEffect(() => {
        let newList: React.ReactNode[] = [];
        for (let i = 0; i < auctionList.length; i++) {
            let status = ItemCardStatus.SUCCESS;

            switch (auctionList[i].startStatus) {
                case StartStatus.UPCOMING:
                    status = ItemCardStatus.NEW;
                    break;
                case StartStatus.ONGOING:
                    status = ItemCardStatus.INPROGRESS;
                    break;
                case StartStatus.PAUSE:
                    status = ItemCardStatus.PAUSE;
                    break;
                case StartStatus.FINISH:
                    status = ItemCardStatus.SUCCESS;
                    break;
                default:
                    status = ItemCardStatus.NEW;
                    break;
            }

            if(auctionList[i].bidderAcceptBid?.status === 3) {
                status = ItemCardStatus.FAILED;
            }

            if (type === "grid") {
                newList.push(
                    <ItemCard status={status} item={auctionList[i]} reloadPage={reloadPage} />
                )
            } else if (type === "list") {
                newList.push(
                    <ItemListCard status={status} item={auctionList[i]} reloadPage={reloadPage} />
                )
            }
        }

        setItemList(newList);
    }, [type, auctionList, reloadPage])

    return (
        <div style={{ marginTop: 25 }}>
            <Row gutter={[10, 10]} align="middle" justify="center">
                {itemList.map((item, index) => {
                    return (
                        <Col
                            xl={type === "grid" ? 8 : 24}
                            xxl={type === "grid" ? 6 : 24}
                            key={index}
                            style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            {item}
                        </Col>
                    )
                })}
            </Row>
        </div>
    )
}

export default AuctionListView;